import React from "react";
import "./lostroute.css";
import Button from "@atlaskit/button";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
const Lostroute = () => {
  const location = useLocation();
  return (
    <div className="lostcontainer">
      <h3>
        {" "}
        <WarningIcon /> You've found a dead link <WarningIcon />
      </h3>
      <Link to="/backup">
        <Button appearance="primary">Go home</Button>
      </Link>
    </div>
  );
};

export default Lostroute;
